import React, { Component } from 'react';
import _ from 'underscore';
import Moment from 'moment';

import {
    Grid,
    Image,
    List,
    Header,
    Segment,
    Message
} from 'semantic-ui-react';


class ProfileNotifications extends Component {

    componentWillMount() {
        this.props.checkAvailableNotification(this.props.user.accessToken).then(() => {
            const {error} = this.props.notificationStatus;
            console.log("check error", error)
            if (error) {
                return;
            }
        });
    }

    render() {

        return (
            <Grid>
                {/*
                    <Grid.Column width={2}>
                        <Image src={props.profilePhoto} fluid circular />
                    </Grid.Column>
                */}

                <Grid.Column width={14}>
                    <Header as='h4' attached='top' block>
                        Recent Notifications
                    </Header>
                    <Segment attached>
                        <List divided relaxed>
                            {
                                _.map(this.props.notifications, (notification) => {
                                    const {
                                        title,
                                        message,
                                        created,
                                        _id
                                    } = notification;
                                    return (
                                        <List.Item key={_id}>
                                            <List.Icon name='bell' />
                                            <List.Content>
                                                <List.Header>{Moment(created).format('DD MMM YYYY hh:mm A')} - {title}</List.Header>
                                                <List.Description>
                                                    {message}
                                                </List.Description>
                                            </List.Content>
                                        </List.Item>
                                    );
                                })
                            }
                            {
                                (this.props.notifications && this.props.notifications.length === 0) ?
                                (
                                    <Message info>
                                        <p>
                                            You are all up-to-date. There is no new notifications.
                                        </p>
                                    </Message>
                                )
                                :
                                null
                            }
                        </List>
                    </Segment>
                </Grid.Column>
            </Grid>
        );
    }
}

export default ProfileNotifications;